window.FavoriteProductsService = function () {
  let fetchFun = new window.fetchdata();
  return {
    add: function (data, successCallback, failedCallback) {
      let url = location.origin + "/service/favoriteProducts/add";
      return fetchFun.fetchData(
        url,
        "POST",
        JSON.stringify(data),
        successCallback,
        failedCallback,
      );
    },
    remove: function (data, successCallback, failedCallback) {
      let url = location.origin + "/service/favoriteProducts/remove";
      return fetchFun.fetchData(
        url,
        "POST",
        JSON.stringify(data),
        successCallback,
        failedCallback,
      );
    },
    get: function (data, successCallback, failedCallback) {
      let url = location.origin + "/service/favoriteProducts/get";
      return fetchFun.fetchData(
        url,
        "GET",
        JSON.stringify(data),
        successCallback,
        failedCallback,
      );
    },
    getProducts: function (successCallback, failedCallback) {
      let url = location.origin + "/service/favoriteProducts/getProducts";
      return fetchFun.fetchData(
        url,
        "GET",
        null,
        successCallback,
        failedCallback,
      );
    },
  };
};

window.favoriteProducts = new window.FavoriteProductsService();
